import { DateInt8 } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Address } from './address.model';
import { Location } from './location.model';
import { Partner } from './partner.model';
import { Stay } from './stay.model';
import { User } from './user.model';

export type PassportRenter = {
    registrationPlate?: string;
    firstName?: string;
    lastName?: string;
    address?: Address;
    phone?: string;
    email?: string;
}

export type PassportCustomer = {
    lastName?: string;
    firstName?: string;
    birthdate?: DateInt8;
    email?: string;
    invitation?: Stay;
    animal?: string;
    vaccine?: boolean;
    category?: number;
};

export type PassportStatus = 'pendingPayment'| 'canceled'| 'validated'| 'needAdditionalPayment';

export type PassportPayment = {
    paidAmount?: number;
    sessionId?: string;
    paidProducts?: {
        quantity?: number;
        productType?: string,
        amount?: number
    }[];
};


@CwtModel({ name: 'passport', path: '/passport' })
export class Passport extends ApiData {
    location?: Location;
    startDate?: DateInt8;
    endDate?: DateInt8;
    partner?: Partner;

    renter?: PassportRenter;
    adults?: PassportCustomer[];
    children?: PassportCustomer[];
    animals?: PassportCustomer[];
    paidSummary: {
        nbAdults: number;
        nbChildren: number;
        nbDays: number;
        nbAnimals: number;
    };
    code?: string;
    status?: PassportStatus;
    owner?: User;
    stripeIntentId?: string;
    stripePaymentId?: string;
    expectedAmount?: number;
    dueAmount?: number;
    payments?: PassportPayment[];
    creationDate?: number;
    digicode?: string;
    comment?: string;

    fieldDictionary() {
        return {
            ...super.fieldDictionary(),
        };
    }   
}